import * as methods from '../methods';
import { Resource } from '../Resource';
import maizy from './maizy';
import tavmills from './tavmills';
const rootPath = 'stages';
/** Restrict which stages you will get */
export var StageUsage;
(function (StageUsage) {
    StageUsage[StageUsage["default"] = 0] = "default";
    StageUsage[StageUsage["bonduelle"] = 1] = "bonduelle";
    StageUsage[StageUsage["bonduelleAgro"] = 3] = "bonduelleAgro";
})(StageUsage || (StageUsage = {}));
const fromRaw = {
    get: ({ id, name, description, index, is_bbch, usages, date, cycle }) => {
        return {
            id,
            name,
            description,
            bbchIndex: index,
            isBbch: is_bbch,
            stageUsages: usages,
            date,
            cycleId: cycle
        };
    }
};
const toRaw = {
    fillDate: ({ date, cycleId }) => ({
        date,
        cycle: cycleId
    })
};
const stages = Resource((requesterBuilder, config) => {
    /** This is not paginated, this is why it does not use methods.getAllPages */
    const getAll = (query) => requesterBuilder({
        path: rootPath,
        requestCtx: {
            transform: (x) => x.map(fromRaw.get),
            params: {
                query: {
                    cycle: query?.cycleId,
                    usage: query?.stageUsage
                }
            }
        }
    });
    const buildKeysToInvalidate = (cropId) => () => [
        maizy(requesterBuilder, config).result({ cropId }).invalidationKey,
        tavmills(requesterBuilder, config).results({ cropId }).invalidationKey
    ];
    return {
        getAll,
        fillDate: (stageId, cropId) => methods.create({
            requesterBuilder,
            rootPath: `${rootPath}/${stageId}/fill_date`,
            fromRaw: fromRaw.get,
            toRaw: toRaw.fillDate,
            buildKeysToInvalidate: buildKeysToInvalidate(cropId)
        })(),
        get: methods.get({ requesterBuilder, rootPath, fromRaw: fromRaw.get })
    };
});
export default stages;
